import React, { Component } from 'react';
import Api from './../../Global/Modules/Api';
import { Link } from 'react-router-dom';
class AnnouncementsOverview extends Component {
  constructor() {
    super();
    this.handlePaginationClick = this.handlePaginationClick.bind(this)
    this.getNews = this.getNews.bind(this)
    this.state = {
      News: [],
      pagination: {
        totalPages: 0,
        currentPage: 0,
        pageSize: 0,
        totalCount: 0
      },
      currentFetchUrl: 'api/news/5/news' // To know where to fetch (to refresh companies) if a company is deleted
    }
  }
  handlePaginationClick(e) {
    const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
    this.setState({ currentFetchUrl: FETCH_URL2 })
    this.getNews(FETCH_URL2)
  }
  componentWillMount() {
    this.getNews('api/news/5/news');
  }
  getNews(fetchUrl) {
    Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {
      this.setState({ pagination: response.pagination }) // Pagination object 
      return response.data.json() // Data -> companies object
    }).then(objectData => {
      if (objectData !== undefined) {
        let news = objectData.news.map(function (item, index) {
          return <div className="announcementItem grey-bg" key={item.id}>
            <div className="announcementItemHeader">{item.title}</div>
            <div className="announcementDescription">{(item.description != null ? item.description.slice(0, 200) + (item.description.length > 200 ? "..." : "") : "")} </div>
            <div className="announcementDescription">{Api.formatDate(item.dateCreated)} </div>
            <div className="announcementReadMore">
              {
                //eslint-disable-next-line
              } <Link to={"/nieuws/nieuws-item/" + item.id}>Lees meer</Link>
            </div>
          </div>
        })
        this.setState({ News: news });
      }
    })
  }
  render() {
    return (
      <div className="route">
        <h1 className="pageTitle">
          Mededelingen
          </h1>
        <div className="announcementsOverview">
          <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
          <div className="announcementsList">
            {this.state.News}
          </div>
          <div className="paginationStyling">
            <div style={{ float: 'left' }}>
              {this.state.pagination.prevButton}
            </div>
            <div style={{ float: 'center' }}>
              Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
            </div>
            <div style={{ float: 'right' }}>
              {this.state.pagination.nextButton}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AnnouncementsOverview;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/AnnouncementsOverview.js